import { ReactElement } from 'react'

// types
import type { DataCollectionFormMediaView } from 'types/issue'

import VideoAsAttachmentList from './components/VideoAsAttachmentList'
import VideoList, { VideoListProps } from './components/VideoList'

const IssueVideoList = ({
  videoResources,
  fieldValue,
  itemsPerRow = 1,
  containerClassName = '',
  toggleDelete,
  onLoad,
  dataCollectionFormMedia,
  showAsAttachmentList,
}: VideoListProps & {
  dataCollectionFormMedia?: DataCollectionFormMediaView[]
  showAsAttachmentList?: boolean
}): ReactElement | null => {
  if (showAsAttachmentList) {
    return (
      <VideoAsAttachmentList
        fieldValue={fieldValue}
        mediaData={dataCollectionFormMedia}
        toggleDelete={toggleDelete}
        onLoad={onLoad}
      />
    )
  }

  return (
    <VideoList
      videoResources={videoResources}
      fieldValue={fieldValue}
      itemsPerRow={itemsPerRow}
      containerClassName={containerClassName}
      toggleDelete={toggleDelete}
      onLoad={onLoad}
    />
  )
}

export default IssueVideoList
